import React, { useEffect, useState } from "react";
import { Alert, Table } from "react-bootstrap";
import { Helmet } from "react-helmet";

import Loader from "../../common/Loader";
import PageTitle from "../../common/PageTitle";
import { getFuelTanks } from "../../services/turgoil-api";

const FuelTanksPage = (): React.ReactElement => {
    const [loading, setLoading] = useState(true);
    const [fuelTanks, setFuelTanks] = useState<any[]>([]);
    const [ipAddresses, setIpAddresses] = useState<string[]>([]);

    useEffect(() => {
        getFuelTanks()
            .then((res) => {
                setLoading(false);
                setFuelTanks(res.fuelTanks || []);
                setIpAddresses(res.ipAddresses || []);
            })
            .catch((err) => {
                setLoading(false);
                console.error(err);
            });
    }, []);

    return (
        <>
            <Helmet>
                <title>Turgoil - Mahutid</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
            </Helmet>
            <PageTitle>Mahutid</PageTitle>
            {loading && <Loader />}
            {!loading && (
                <>
                    {ipAddresses.length && (
                        <Alert variant="info">
                            Selleks, et mahutite informatsiooni kuvada on vaja anda ligipääs järgmistele Turgoil-i
                            IP aadressidele: {ipAddresses.join(' ja ')}.
                        </Alert>
                    )}
                    {fuelTanks.length === 0 && (
                        <span>Teil ei ole ühtegi mahutit. Mahutite seadistamiseks võtke meiega ühendust&nbsp;
                            <a href="mailto:info@turgoil.com">info@turgoil.com</a> või <a href="tel:+3725138940">+372 513 8940</a>
                        </span>
                    )}
                    {fuelTanks.length && (
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>Mahuti nr</th>
                                    <th>Väärtus</th>
                                    <th>Arvutuslik väärtus</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fuelTanks.filter((f) => f.aiValueRaw !== 0).map((f) => (
                                    <tr>
                                        <td>{f.aiIndex}</td>
                                        <td>{f.aiValueRaw}</td>
                                        <td>{f.aiValueScaled}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </>
            )}
        </>
    )
}

export default FuelTanksPage;
